export interface LoaderProps {
  message?: string;
}

export const Loader = ({ message }: LoaderProps): React.JSX.Element => (
  <div className="w-max">
    <div className="relative flex items-center justify-center">
      <div className="relative inline-block h-10 w-10">
        <div
          className="absolute left-1 inline-block w-2 animate-loader"
          style={{ animationDelay: '-0.24s' }}
        />
        <div
          className="absolute left-4 inline-block w-2 animate-loader"
          style={{ animationDelay: '-0.12s' }}
        />
        <div className="absolute left-7 inline-block w-2 animate-loader" />
      </div>
    </div>
    {message && <span className="text-center text-xs">{message}</span>}
  </div>
);
